import { CardBody, Badge } from "reactstrap";
import { P } from "../../../../AbstractElements";

const BugsReportedBody = ({ bugs }) => {
  return (
    <CardBody className="chat-box pt-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
      <div className="bug-list">
        {bugs && bugs.length > 0 ? (
          bugs.map((bug, index) => (
            <div
              key={index}
              className="bug-item mb-3 p-3"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                borderLeft: `4px solid ${getStatusColor(index)}`,
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div className="d-flex justify-content-between align-items-center mb-0">
                <P
                  attrPara={{
                    className: "mb-0 font-weight-bold",
                    style: { wordBreak: "break-word", whiteSpace: "normal" },
                  }}
                >
                  <strong className="me-2">Message:</strong> {bug?.errorMessage}
                </P>
                <Badge color={bug?.resolved ? "success" : "danger"} pill>
                  {bug?.resolved ? "Resolved" : "Pending"}
                </Badge>
              </div>
              <P
                attrPara={{
                  className: "mb-0",
                  style: { wordBreak: "break-word", whiteSpace: "normal" },
                }}
              >
                <strong>Email:</strong> {bug.email}
              </P>
              <P
                attrPara={{
                  className: "mb-0 text-muted",
                  style: { wordBreak: "break-word", whiteSpace: "normal" },
                }}
              >
                <small>
                  Reported on:{" "}
                  {new Date(bug.createdAt.seconds * 1000).toLocaleString()}
                </small>
              </P>
              <P
                attrPara={{
                  className: "mb-0 text-muted",
                  style: { wordBreak: "break-word", whiteSpace: "normal" },
                }}
              >
              <a className="link-hover-effect" href={`/bug?isOpenDetails=true&id=${bug?.id}`} target="_blank">View Details</a>
              </P>
            </div>
          ))
        ) : (
          <P attrPara={{ className: "text-center text-muted" }}>
            No bugs found.
          </P>
        )}
      </div>
    </CardBody>
  );
};

const getStatusColor = (index) => {
  const colors = ["#28a745", "#dc3545", "#007bff", "#ffc107", "#17a2b8"];
  return colors[index % colors.length];
};

export default BugsReportedBody;